import React from 'react';

import PropTypes from 'prop-types';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

const LinkField = (props) => {
    return (
        <Panel type={props.type} to={props.to} onClick={props.onClick} negativeMargin={props.negativeMargin} isHoverable hasIcon>
            <IconWrapper>
                <Icon name={props.icon} color="primary" />
            </IconWrapper>
            <Text color={props.emphasizedtext ? 'emphasized' : null}>{props.text}</Text>
        </Panel>
    );
};
LinkField.propTypes = {
    type: PropTypes.string,
    to: PropTypes.string,
    onClick: PropTypes.func,
    negativeMargin: PropTypes.bool,
    icon: PropTypes.string,
    emphasizedtext: PropTypes.bool,
    text: PropTypes.string,
};

export default LinkField;
